export default ['hired', 'hired_and_archived', 'declined', 'passed', 'not_your_refer', 'expired', 'archived'];
